export function modifyLangString(language) {
    return language.replace(/['"]+/g, '').substring(0,2)
}